import { useState } from 'react';
import { Period } from '../modules/Components/PeriodSelector/PeriodMenu';
import { AppBarContextInterface } from './BusinessPortalAppBarContext';

const useAppBar = (): AppBarContextInterface => {
  const [showAppBar, setShowAppBar] = useState(true);
  const [showHistoryButtons, setShowHistoryButtons] = useState(true);
  const [showPeriodSelector, setShowPeriodSelector] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState<Period | undefined>();
  const [valueInputNavigationTarget, setNavigationTarget] = useState<string | undefined>();

  const setAppBar = (value: boolean): void => {
    setShowAppBar(value);
  };

  const setHistoryButtons = (value: boolean): void => {
    setShowHistoryButtons(value);
  };

  const setPeriodSelector = (value: boolean): void => {
    setShowPeriodSelector(value);
  };

  const setPeriod = (value: Period): void => {
    setSelectedPeriod(value);
  };

  const setValueInputNavigationTarget = (target: string) => setNavigationTarget(target);

  const getPeriodName = (): string => selectedPeriod?.name || 'current';

  return {
    showAppBar,
    setAppBar,
    showHistoryButtons,
    setHistoryButtons,
    selectedPeriod,
    setPeriod,
    showPeriodSelector,
    setPeriodSelector,
    getPeriodName,
    valueInputNavigationTarget,
    setValueInputNavigationTarget
  };
};

export default useAppBar;
